// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
    background: #050A30;
    width: 100%;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    transition: all 0.3s ease-in-out;
}

.left-section {
    display: flex;
    align-items: center;
    gap: 10px;
}

.btn-toggle {
    background: none;
    border: none;
    color: white;
    font-size: 24px;
    cursor: pointer;
    transition: transform 0.3s ease-in-out;
}

.btn-toggle:hover {
    transform: scale(1.1);
}

.content-logo {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background-color: #fff;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.animated-logo {
    width: 70px;
    height: 70px;
}

.brand-text {
    color: white;
    font-size: 18px;
    font-weight: bold;
    margin-left: 10px;
}

.btn-custom {
    background: linear-gradient(45deg, #ff416c, #ff4b2b);
    color: white;
    font-size: 14px;
    font-weight: bold;
    border: none;
    padding: 8px 16px;
    border-radius: 30px;
    transition: all 0.3s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 4px 10px rgba(255, 65, 108, 0.4);
    cursor: pointer;
}

.btn-custom:hover {
    transform: scale(1.05);
    box-shadow: 0px 6px 15px rgba(255, 65, 108, 0.6);
}

.btn-custom:active {
    transform: scale(0.95);
}

@media (max-width: 768px) {
    .navbar {
        height: 60px;
        padding: 0 10px;
    }

    .btn-toggle {
        font-size: 20px;
    }

    .content-logo {
        width: 40px;
        height: 40px;
    }

    .animated-logo {
        width: 70px;
        height: 70px;
    }

    .brand-text {
        font-size: 16px;
        display: block;
    }

    .btn-custom {
        font-size: 12px;
        padding: 6px 12px;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/style/header.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,oDAAoD;IACpD,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gDAAgD;IAChD,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,gDAAgD;AACpD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ","sourcesContent":[".navbar {\n    background: #050A30;\n    width: 100%;\n    height: 70px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 15px;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1050;\n    transition: all 0.3s ease-in-out;\n}\n\n.left-section {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.btn-toggle {\n    background: none;\n    border: none;\n    color: white;\n    font-size: 24px;\n    cursor: pointer;\n    transition: transform 0.3s ease-in-out;\n}\n\n.btn-toggle:hover {\n    transform: scale(1.1);\n}\n\n.content-logo {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 45px;\n    height: 45px;\n    border-radius: 50%;\n    background-color: #fff;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n}\n\n.animated-logo {\n    width: 70px;\n    height: 70px;\n}\n\n.brand-text {\n    color: white;\n    font-size: 18px;\n    font-weight: bold;\n    margin-left: 10px;\n}\n\n.btn-custom {\n    background: linear-gradient(45deg, #ff416c, #ff4b2b);\n    color: white;\n    font-size: 14px;\n    font-weight: bold;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 30px;\n    transition: all 0.3s ease-in-out;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0px 4px 10px rgba(255, 65, 108, 0.4);\n    cursor: pointer;\n}\n\n.btn-custom:hover {\n    transform: scale(1.05);\n    box-shadow: 0px 6px 15px rgba(255, 65, 108, 0.6);\n}\n\n.btn-custom:active {\n    transform: scale(0.95);\n}\n\n@media (max-width: 768px) {\n    .navbar {\n        height: 60px;\n        padding: 0 10px;\n    }\n\n    .btn-toggle {\n        font-size: 20px;\n    }\n\n    .content-logo {\n        width: 40px;\n        height: 40px;\n    }\n\n    .animated-logo {\n        width: 70px;\n        height: 70px;\n    }\n\n    .brand-text {\n        font-size: 16px;\n        display: block;\n    }\n\n    .btn-custom {\n        font-size: 12px;\n        padding: 6px 12px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
